import knowledgeHero from "@/assets/knowledge-hero-new.jpg";
import { Button } from "@/components/ui/button";
const KnowledgeSection = () => {
  return <section className="w-full py-16 md:py-24 bg-background">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-serif font-normal mb-6 text-foreground">
            <span className="md:hidden">Give your store<br />AI superpowers.<br />In a single workflow.</span>
            <span className="hidden md:inline">Give your store AI superpowers.<br />In a single workflow.</span>
          </h2>
          <p className="text-base text-gray-600 max-w-3xl md:text-xl">
            Unlock the speed and intelligence to grow faster than ever. From generating ad creatives to managing profit, thinker.os works alongside you to build a better business.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 border-t border-border pt-12 mb-12">
          <div className="text-left">
            <p className="text-sm md:text-base text-gray-600 mb-2">Up to</p>
            <p className="text-5xl md:text-6xl lg:text-7xl font-serif font-normal mb-3 text-blue-600">10x</p>
            <p className="text-base md:text-lg text-gray-600">faster creative production</p>
          </div>
          
          <div className="text-left">
            <p className="text-sm md:text-base text-gray-600 mb-2">Up to</p>
            <p className="text-5xl md:text-6xl lg:text-7xl font-serif font-normal mb-3 text-blue-600">25%</p>
            <p className="text-base md:text-lg text-gray-600">higher conversion rate</p>
          </div>
          
          <div className="text-left">
            <p className="text-sm md:text-base text-gray-600 mb-2">Up to</p>
            <p className="text-5xl md:text-6xl lg:text-7xl font-serif font-normal mb-3 text-blue-600">40%</p>
            <p className="text-base md:text-lg text-gray-600">lower operational costs</p>
          </div>
          
          <div className="text-left">
            <p className="text-sm md:text-base text-gray-600 mb-2">Up to</p>
            <p className="text-5xl md:text-6xl lg:text-7xl font-serif font-normal mb-3 text-blue-600">3x</p>
            <p className="text-base md:text-lg text-gray-600">faster time to market</p>
          </div>
        </div>

        <div className="mb-12 md:mb-16">
          <img src={knowledgeHero} alt="AI-powered ecommerce platform dashboard interface" loading="lazy" decoding="async" className="w-full h-auto rounded-lg" />
        </div>

        {/* CTA */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button size="lg" asChild>
            <a href="https://www.thinkr.studio/">See How It Works</a>
          </Button>
          <Button size="lg" variant="outline">
            View Pricing
          </Button>
        </div>
      </div>
    </section>;
};
export default KnowledgeSection;